import React from 'react';
import { Button, Col, Modal, Row, Spinner } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

const AlertModal = ({
  show,
  onHide,
  onContinueClick,
  onDismissClick,
  dismissButtonText = 'Dismiss',
  dismissButtonVariant = 'secondary',
  continueButtonText = 'Continue',
  continueButtonVariant = 'danger',
  hideContinueButton = false,
  AlertIcon = ExclamationTriangleFill,
  showProgress,
  title = 'Heads Up!',
  alertText,
  progressText,
  extraContent = null,
}) => (
  <Modal show={show} onHide={onHide} centered backdrop="static" style={{ zIndex: '99999' }}>
    <Modal.Header>
      <Modal.Title>
        <h6 className="mb-0">{title}</h6>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="overflow-auto">
      <Row>
        <Col className="text-center">
          <AlertIcon className="text-danger" size={30} />
          <h6 className="mt-3"> {alertText} </h6>
        </Col>
      </Row>
      {
        extraContent && (
          <Row>
            <Col className="text-center">
              {extraContent}
            </Col>
          </Row>
        )
      }
    </Modal.Body>
    <Modal.Footer>
      <Button
        size="sm"
        disabled={showProgress}
        className="ml-2 px-2"
        variant={dismissButtonVariant}
        onClick={onDismissClick}
      >
        {dismissButtonText}
      </Button>
      {!hideContinueButton && typeof onContinueClick === 'function' && (
        <Button
          size="sm"
          disabled={showProgress}
          className="ml-2 px-2 d-inline-flex align-items-center justify-content-center"
          variant={continueButtonVariant}
          onClick={onContinueClick}
        >
          {showProgress && <Spinner size="sm" animation="border" className="mr-1" />}
          {continueButtonText}
        </Button>
      )}
    </Modal.Footer>
  </Modal>
);

export default AlertModal;
